import {BlockHighlightVisualizationEnum} from '@sdox/api'

import type {XcNwBlockFragment} from '@sdox/api'

export type CreatableBlockType = XcNwBlockFragment['__typename'] | 'TextImage'

export const getCreatableTypeFromBlock = (block: XcNwBlockFragment): CreatableBlockType => {
  const typename = block.__typename
  if (typename === 'BlockHighlightType') {
    if (
      block.highlightVisualization === BlockHighlightVisualizationEnum.TextImage ||
      block.highlightVisualization === BlockHighlightVisualizationEnum.TextImageViceVersa
    ) {
      return 'TextImage'
    }
  }
  return typename
}

export const getCreatableNameByType = (type: CreatableBlockType): string => {
  return type
    .replace(/Block/g, '')
    .replace(/Type/g, '')
    .replace(/Row/g, '')
    .replace(/Media/g, '')
    .split(/(?=[A-Z])/)
    .join(' ')
}

export const getCreatableNameByBlock = (block: XcNwBlockFragment): string => {
  return getCreatableNameByType(getCreatableTypeFromBlock(block))
}
